





import React from 'react'
import './Footer.css'
function Footer(){
    return(
        <>
           <div className="footer">
            <p>Copyright © 2024 Rediet Gashaw. All Rights Reserved.</p>
           </div>


         
        </>
    )
}
export default Footer